'use client';

/**
 * CartFloatingButton — botón flotante que muestra el contador de items
 * del carrito y abre el drawer al hacer click.
 *
 * Feature (v136): UX improvement — el usuario necesita ver cuántos items
 * tiene en el carrito sin abrir el drawer. El botón flotante en la
 * esquina inferior derecha del marketplace lo permite.
 */

import { ShoppingCart } from 'lucide-react';
import { useCart } from '@/lib/cart/store';
import { Badge } from '@/components/ui/badge';

export function CartFloatingButton() {
  const { totalCount, setIsOpen, items } = useCart();

  if (items.length === 0) return null;

  return (
    <button
      type="button"
      onClick={() => setIsOpen(true)}
      className="fixed bottom-20 right-4 z-[55] inline-flex items-center justify-center gap-2 rounded-full bg-primary text-primary-foreground shadow-lg hover:bg-primary/90 transition-all px-5 py-3.5 text-sm font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
      aria-label={`Abrir carrito (${totalCount} ${totalCount === 1 ? 'producto' : 'productos'})`}
    >
      <ShoppingCart className="size-5" aria-hidden="true" />
      {totalCount > 0 && (
        <Badge
          variant="destructive"
          className="absolute -top-1 -right-1 min-w-5 h-5 px-1 flex items-center justify-center text-xs font-bold"
        >
          {totalCount > 99 ? '99+' : totalCount}
        </Badge>
      )}
    </button>
  );
}
